var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.29,
    height: 26.622,
    viewBox: "0 0 25.29 26.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-5208215_1_",
    "data-name": "noun-edit-5208215 (1)",
    transform: "translate(-150 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12409",
    "data-name": "Path 12409",
    d: "M315.418,100a1.331,1.331,0,0,1,.941.39l4.545,4.545a1.331,1.331,0,0,1,0,1.882l-13.635,13.635a1.33,1.33,0,0,1-.821.384l-5,.455A1.331,1.331,0,0,1,300,119.846l.454-5a1.331,1.331,0,0,1,.384-.821l13.635-13.635a1.331,1.331,0,0,1,.941-.39Zm-2.208,5.422,2.663,2.663,2.208-2.208-2.663-2.663Zm.78,4.545-2.663-2.663-8.263,8.263L302.8,118.5l2.929-.266Z",
    transform: "translate(-146.003)",
    fill: "#038de3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.23555a37c3cf60aef3addb1cc1d89a03.svg";
export { ForwardRef as ReactComponent };